/**
 * BotaoGrande — botao de toque para crianca de 5 anos.
 *
 * D3: nunca menor que 80x80 px. O minimo esta travado no CSS abaixo; se alguem
 *     tentar encolher, o botao ignora.
 * D2: e um <button>, entao responde a toque e clique. Nao ha atalho de teclado
 *     obrigatorio em lugar nenhum.
 * D4: o retorno visual sai no :active, instantaneo.
 */

const TAMANHO_MINIMO = 96; // acima do minimo de 80 exigido por D3

let estiloInjetado = false;

function injetarEstilo() {
  if (estiloInjetado) return;
  estiloInjetado = true;

  const estilo = document.createElement('style');
  estilo.textContent = `
    .botao-grande {
      position: fixed;
      min-width: ${TAMANHO_MINIMO}px;
      min-height: ${TAMANHO_MINIMO}px;
      border: none;
      border-radius: 24px;
      background: #ffffff;
      color: #33372c;
      font-family: system-ui, -apple-system, sans-serif;
      font-size: 40px;
      line-height: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 6px 0 rgba(0, 0, 0, 0.18);
      cursor: pointer;
      touch-action: manipulation;
      -webkit-tap-highlight-color: transparent;
      transition: transform 90ms ease, box-shadow 90ms ease;
      z-index: 10;
    }
    /* D4 — feedback em menos de 200 ms */
    .botao-grande:active {
      transform: translateY(4px);
      box-shadow: 0 2px 0 rgba(0, 0, 0, 0.18);
    }
    .botao-grande--casa { top: 24px; left: 24px; }
  `;
  document.head.appendChild(estilo);
}

export class BotaoGrande {
  /**
   * @param {object} opcoes
   * @param {string} opcoes.simbolo   emoji ou caractere mostrado no botao
   * @param {string} opcoes.rotulo    descricao para leitor de tela
   * @param {string} [opcoes.canto]   'casa' posiciona no canto padrao (D9)
   * @param {Function} opcoes.aoTocar
   */
  constructor({ simbolo, rotulo, canto, aoTocar }) {
    injetarEstilo();

    this.elemento = document.createElement('button');
    this.elemento.className = 'botao-grande';
    if (canto) this.elemento.classList.add(`botao-grande--${canto}`);
    this.elemento.textContent = simbolo;
    this.elemento.setAttribute('aria-label', rotulo);
    this.elemento.type = 'button';

    this.elemento.addEventListener('click', aoTocar);
    document.body.appendChild(this.elemento);
  }

  mostrar() {
    this.elemento.style.display = 'flex';
  }

  esconder() {
    this.elemento.style.display = 'none';
  }

  descartar() {
    this.elemento.remove();
  }
}

/**
 * D9 — botao de casa grande, SEMPRE no mesmo canto, saindo de qualquer tarefa
 * a qualquer momento. Ele nunca some da tela durante a sessao.
 */
export function criarBotaoCasa(aoTocar) {
  return new BotaoGrande({
    simbolo: '\u{1F3E0}',
    rotulo: 'Voltar para a fazenda',
    canto: 'casa',
    aoTocar,
  });
}
